import React, { Component, useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import MyProfileView from './MyProfileView';
import crmservices from '../../wsclient/crmservices'
import t from '../../utils/translateUtil';
import Loading from '../../components/Loading';
import ModalAlert from '../../components/ModalAlert';
import { getAppCfg, getCountryDefault, getCountryDefaultByCode } from '../../utils/common'
import moment from "moment";
import { isThisHour, isThisSecond } from 'date-fns';
import ChangePassword from './ChangePassword';
import MerrchantVenueStore from './MerrchantVenueStore';
import { setOrderCache, order_key, getOrderCache } from '../../utils/order_cache';
import { preferences_type } from '../../wsclient/crmservices/dataUtil';
import Addresses from '../addresses/Addresses';
import AddAdresses from '../addresses/AddAdresses';
import { airlinkservices } from '../../wsclient/crmservices/airlinkservices';
const styles = theme => ({

});
function MyProfile(props) {
    var app_config = getAppCfg();
    var agreement_countries = app_config && app_config.contact && app_config.contact.agreement_countries ? app_config.contact.agreement_countries : null
    var country_default = getCountryDefault(agreement_countries);

    const [profile, setProfile] = useState({});
    const [profile_demographics, setProfileDemographics] = useState({});
    const [profile_phone, setProfilePhone] = useState({});
    const [new_phone, setNewPhone] = useState({ number: '' });
    const [showLoading, onShowLoading] = useState(false);
    const [showProcessLoading, onShowProcessLoading] = useState(false);
    const [error, setError] = useState({
        showAlert: false,
        close: true,
        message: '',
        status: '',
    });
    const [isChangePassword, onOpenChangePassword] = useState(false);
    const [showListMerchant, setShowListMerchant] = useState(false);
    const [merchants, setMerchants] = useState([]);
    const [venues, setVenues] = useState([]);
    const [preference_type, setPreferenceType] = useState(null);
    const [openAddress, onOpenAddress] = useState(false);
    const [country_select, onSelectCountry] = useState(country_default ? country_default : { value: 'CYP', phone_code: '357' });
    const [list_nameday, setListNameDay] = useState([]);
    const [isNameDay, setIsNameDay] = useState(false);
    const [addresses, setAddresses] = useState({});
    const [addAddresses, setAddAddresses] = useState({
        open: false,
        mode: null,
        address: null
    })
    const [preferredCommunicationMethod, setPreferredCommunicationMethod] = useState(null);
    const [preferredCommunicationMethods, setPreferredCommunicationMethods] = useState([]);
    const [isLoadedPreferred, setIsLoadedPreferred] = useState(false);

    const auth_support = app_config.auth_support;
    const features = app_config.features;

    useEffect(() => {
        onLoadData();
    }, []);

    const onLoadData = async () => {
        await onLoadCustomfield();
        await onLoadProfile();
        onLoadFavouriteShop();
        onLoadAddresses();
    }

    const onShowMerchantList = async (type) => {
        if (!showListMerchant) {
            if (type === preferences_type.order)
                await loadVenue();
            else
                await loadMerchant();

            setPreferenceType(type);
        }
        setShowListMerchant(!showListMerchant);

    }
    const loadMerchant = async () => {
        onShowLoading(true);
        try {
            var result = await crmservices.rewards.getOrgLocations({ relationship: 'MERCHANT', countries: profile.country_agreement });
            // console.log('loadMerchant result==',result)
            if (result.code == 'OK') {
                setMerchants(result.data.content);
            }
        } catch (error) {
            console.log("get all merchant exception:", error);
        }
        onShowLoading(false);
    }
    const loadVenue = async () => {
        onShowLoading(true);
        try {
            var result = await crmservices.rewards.getOrgLocations({ countries: profile.country_agreement });
            //console.log('loadVenue result==',result)
            if (result.code == 'OK') {
                var content = result.data.content;
                if (content && content.length > 0) {
                    var merchants = [];
                    for (let j = 0; j < content.length; j++) {
                        var operation_details = content[j].operation_details;
                        if (operation_details && operation_details.short_term_operations && operation_details.short_term_operations.length > 0) {
                            var isClosed = true;
                            for (let i = 0; i < operation_details.short_term_operations.length; i++) {
                                if (operation_details.short_term_operations[i].operation === "DELIVERY" || operation_details.short_term_operations[i].operation == "PICK_UP") {
                                    if (!operation_details.short_term_operations[i].is_closed) {
                                        isClosed = false;
                                    }
                                }
                            }
                            if (!isClosed) {
                                merchants.push(content[j])
                            }
                        }
                    }
                    setVenues(merchants)
                }
            }
        } catch (error) {
            console.log("get all venue exception:", error);
        }
        onShowLoading(false);
    }
    const onUpdatePreferrence = async (item) => {
        onShowProcessLoading(true)
        try {
            var result = await crmservices.contacts.addContactPreferences(item.id, preference_type);
            //console.log("AAAAAAAAAAAA result:",result);
            if (result.code == 'OK') {
                setShowListMerchant(false);
                await onLoadFavouriteShop();
            } else {
                showAlert(t('ERROR'), t('EXCEPTION_PROCESS'));
            }
        } catch (error) {
            console.log('add favourite shop exception:', error);
            showAlert(t('ERROR'), t('EXCEPTION_PROCESS'));
        }
        onShowProcessLoading(false);
    }
    const onLoadFavouriteShop = async () => {
        try {
            var result = await crmservices.contacts.getContactPreferences();
            //console.log("AAAAAAAAAAAA result:", result);
            if (result.code == 'OK') {
                setOrderCache(order_key.order_favourite_shop, result.data && result.data.organisations ? result.data.organisations : []);
            }
        } catch (error) {
            console.log('load favourite shop exception:', error);
        }
    }
    const onEdit = async (value) => {
        var new_profile = { ...profile };
        var new_profile_demographics = { ...profile_demographics }
        var new_phone = { ...profile_phone };
        //console.log('onEdit = ',value)
        new_phone.number = value.phone
        new_profile.first_name = value.first_name;
        new_profile.last_name = value.last_name;
        new_profile.email_address = value.email_address;
        new_profile.statutory_number = value.statutory_number;

        const birth_day = new Date(value.date_of_birth)
        //console.log('birth_day===',birth_day)
        new_profile_demographics.date_of_birth = { month: birth_day.getMonth() + 1, day: birth_day.getDate(), year: birth_day.getFullYear() };
        new_profile_demographics.passport = {
            passport_number: value.passport_number
        }
        new_profile_demographics.id_details = {
            id_number: value.id_number
        }

        setProfile(new_profile);
        setNewPhone(new_phone)
        onShowProcessLoading(true);
        try {
            let domain = document._portalConfig?.domainCustomer || 'airlink';
            //console.log('new_phone new_phone==',new_phone)
            //console.log('updateContact profile_demographics==',profile_demographics)
            var result = await crmservices.contacts.updateContact({ ...new_profile }, { ...new_profile_demographics });
            var resultupdateCustomfield = await airlinkservices.updateCustomfield({ 
                domain: domain, 
                type: preferredCommunicationMethod && preferredCommunicationMethod.value,
                order: preferredCommunicationMethod && preferredCommunicationMethod.order,
            })
            //console.log('updateContact result==',result)
            if (result.code == 'OK' && resultupdateCustomfield.code == 'OK') {
                if (new_phone.number !== undefined)
                    await checkAndUpdatePhone(new_phone);
                //  if(updatePhone)
                //}
                await onLoadProfile();
                showAlert(t('SUCCESS'), t('PROFILE_UPDATE_SUSCESS'));
            } else {
                showAlert(t('ERROR'), t('UPDATE_FAIL'));
            }
        } catch (error) {
            console.log("update profile error:", error);
            showAlert(t('ERROR'), t('EXCEPTION_PROCESS'));
        }
        onShowProcessLoading(false);
    }

    const checkAndUpdatePhone = async (new_phone) => {
        try {
            var phone_number = new_phone
            var currentPhone = { ...profile_phone };
            var country_code = country_select.value;
            var isUpdate = false;
            var isAdd = false;
            var isDelete = false;
            //console.log("AAAAAAAAAAA phone_number:", phone_number);
            //console.log("AAAAAAAAAAA currentPhone:", currentPhone);
            if (phone_number && phone_number.number && currentPhone && currentPhone.number) {
                if (phone_number.number != currentPhone.number || country_code != phone_number.country_code) {
                    isUpdate = true;
                }
            }
            else if ((!currentPhone || !currentPhone.number) && phone_number) {
                isAdd = true;
            }
            else if (!phone_number.number && currentPhone && currentPhone.number) {
                isDelete = true;
            }
            //console.log("AAAAAAAAAAA phone_number:", phone_number);
            //console.log("AAAAAAAAAAA isDelete:", isDelete);
            //console.log("AAAAAAAAAAA isUpdate:", isUpdate);
            //console.log("AAAAAAAAAAA isAdd:", isAdd);
            if (!isDelete && !isAdd && !isUpdate)
                return true;
            var result = null;
            if (isAdd) {
                result = await crmservices.contacts.addPhone({ ...phone_number, country_code: country_code, is_primary: true });
            }
            if (isUpdate) {
                result = await crmservices.contacts.updatePhone({ ...phone_number, phone_id: phone_number.id, country_code: country_code });
            }
            if (isDelete) {
                result = await crmservices.contacts.deletePhone(phone_number.id);
            }
            //console.log('checkAndUpdatePhone result=', result)
            if (result.code != 'OK') {
                showAlert(t('ERROR'), t('UPDATE_FAIL'));
            } else {
                return true;
            }
        } catch (error) {
            showAlert(t('ERROR'), t('EXCEPTION_PROCESS'));
        }
    }

    const onLoadProfile = async (isRefresh) => {
        onShowLoading(true);
        try {
            var result = await crmservices.contacts.getContact();
            console.log("result getContact ===", result);
            if (result.code === 'OK') {
                setProfile({ ...result.data });
                if (result.data && result.data.custom_fields && result.data.custom_fields.length > 0) {
                    let existPreCommunication = result.data.custom_fields.filter(x => x.key == 'preferred_communication_method');
                    if (existPreCommunication && existPreCommunication.length > 0) {
                        setPreferredCommunicationMethod(existPreCommunication[0])
                    }
                }
                setIsLoadedPreferred(true)
                //var listNameDay = await crmservices.contacts.getListNameDay('Holly Mary')
                //console.log('listNameDay====', listNameDay)
                var demographicsResult = await crmservices.contacts.getContactDemographics();
                console.log('demographicsResult onLoadProfile result=', demographicsResult)
                if (demographicsResult.code === 'OK') {
                    let isNameDay = demographicsResult.data.name_day && demographicsResult.data.name_day.month && demographicsResult.data.name_day.day
                    let isSupportNameDay = getSupportProfileDetail("NAMEDAY");
                    if (!isNameDay && isSupportNameDay) {
                        var resultNameDayRules = await crmservices.contacts.getNameDayRules(result.data.first_name);
                        //console.log('MyProfile resultgetNameDayRules result=', resultNameDayRules)
                        if (resultNameDayRules.code === 'OK') {
                            if (resultNameDayRules.data.length > 0)
                                setListNameDay(resultNameDayRules.data);
                            else
                                showAlert(t('ERROR'), t('NAMEDAY_NOT_CONFIG'))
                        }
                    }
                    else {
                        setListNameDay([demographicsResult.data.name_day]);
                    }
                    setProfileDemographics({ ...demographicsResult.data });
                    setIsNameDay(isNameDay);
                }
                var phoneResult = await crmservices.contacts.getPhones();
                //console.log('MyProfile onLoadProfile phoneResult=', phoneResult)
                if (phoneResult.code === 'OK') {
                    var content = phoneResult.data.content;
                    if (content && content.length > 0) {
                        var phone = content.filter(p => p.is_primary);
                        if (phone && phone.length > 0) {
                            //console.log(' set profile_phone=== ', content[0])
                            setProfilePhone({ ...content[0] });
                            var country_code = content[0].country_code;
                            if (country_code) {
                                var country_default = getCountryDefaultByCode(country_code);
                                console.log("AAAA country_default:", country_default);
                                if (country_default) {
                                    onSelectCountry(country_default);
                                }

                            }
                        }
                    } else {
                        setProfilePhone({});
                    }
                }
            } else {
                showAlert(t('ERROR'), t('EXCEPTION_PROCESS'));
            }


        } catch (error) {
            showAlert(t('ERROR'), t('EXCEPTION_PROCESS'));
        }
        onShowLoading(false);
    }
    const onChangeGender = (value) => {
        setProfileDemographics(prevState => ({
            ...prevState,
            gender: value
        }))
    }
    const onChangePassword = async (values) => {
        onShowLoading(true);
        if (values && values.new_password) {
            try {
                var updatePassword = await crmservices.contacts.changePassword(values.new_password);
                //console.log(' onChangePassword réult ===', updatePassword)
                if (updatePassword.code === 'OK')
                    showAlert(t('SUCCESS'), t('CHANGE_PASSWORD_SUCCESS'));
                else if (updatePassword.code === 'INVALID_CONTACTPASSWORD_EXCEPTION')
                    showAlert(t('ERROR'), t('INVALID_CONTACTPASSWORD_EXCEPTION'));
                else
                    showAlert(t('ERROR'), t('CHANGE_PASSWORD_FAIL'));
            }
            catch (error) {
                console.log("change password exception:", error);
                showAlert(t('ERROR'), t('EXCEPTION_PROCESS'));
            }
        }
        onOpenChangePassword(!isChangePassword)
        onShowLoading(false);
    }
    const onSelectNameDay = (values) => {
        let arr = values.target.value.split('/')
        setProfileDemographics(prevState => ({
            ...prevState,
            name_day: {
                day: Number(arr[0]),
                month: Number(arr[1])
            }
        }));

    }
    const showAlert = (status, message, close) => {
        onShowLoading(false);
        onShowProcessLoading(false);
        setError({
            showAlert: true,
            message: message,
            status: status,
            close: close
        });
    }
    const onCloseAlert = () => {

        if (error.close)
            props.handleDrawerOtherToggle("my_profile")

        onShowLoading(false);
        setError({
            showAlert: false,
            message: '',
            status: '',
            close: true
        });
    }

    const getSupportProfileDetail = (type) => {
        var isSupported = false;
        var app_config = getAppCfg();
        if (app_config && app_config.contact && app_config.contact.profile_details) {
            var profile_details = app_config.contact.profile_details;
            var exitsItem = profile_details.filter(e => {
                return e.type === type;
            })
            if (exitsItem && exitsItem.length > 0 && exitsItem[0].is_supported) {
                isSupported = true;
            }
        }
        return isSupported;
    }

    const onLoadAddresses = async () => {
        onShowLoading(true)
        try {
            var result = await crmservices.contacts.getAddresses();
            console.log('onLoadAddresses result==', result)
            if (result.code === 'OK') {
                var addresses = result.data && result.data.content ? result.data.content : [];
                setAddresses(addresses)
            }
        } catch (error) {
            console.log('load addresses exception:', error);
        }
        onShowLoading(false);
    }

    const onShowDetailAddress = (add) => {
        //console.log(' add=====', add)
        var from = props.from;
        setAddAddresses(prevState => ({
            ...prevState,
            open: true,
            mode: 'edit',
            address: add
        }))
    }

    const onCloseAddAddresses = () => {
        setAddAddresses(prevState => ({
            ...prevState,
            open: false,
        }));
    }

    const onSelectMethod = (type) => {
        console.log("AAAA onSelectMethod type: ", type)
        setPreferredCommunicationMethod(prevState => ({
            ...prevState,
            value: type,
        }))
    }

    const onLoadCustomfield = async () => {
        onShowLoading(true); 
        try {
            let domain = document._portalConfig?.domainCustomer || 'airlink';
            const entity = "CONTACTS";
            const result = await airlinkservices.getCustomfield(domain, entity);
            console.log('onLoadCustomfield result:', result);
            if (result.code === 'OK') {
                if (result.data && result.data.content && result.data.content.length > 0) {
                    let existPreCommunication = result.data.content.filter(x => x.key == 'preferred_communication_method');
                    if (existPreCommunication && existPreCommunication.length > 0) {
                        if (existPreCommunication[0].options && existPreCommunication[0].options.length > 0) {
                            let _options = [];
                            existPreCommunication[0].options.forEach(element => {
                                _options.push({
                                    value: element.key,
                                    label: element.text,
                                    order_number: element.order_number,
                                    default: element.default,
                                })
                            });
                            setPreferredCommunicationMethod(prevState => ({
                                ...prevState,
                                order: existPreCommunication[0].order,
                            }))
                            setPreferredCommunicationMethods(_options)
                        }
                    }
                }
            } else {
                console.log('No valid custom field data found.');
            }
        } catch (error) {
            console.error('Error loading custom fields:', error);
        } finally {
            onShowLoading(false);
        }
    };
    

    const onRemoveAddress = async (address) => {
        //console.log("address:", address);
        onShowLoading(true);
        try {
            var result = await crmservices.contacts.removeAddress(address.id);
            if (result.code == 'OK') {
                await onLoadAddresses();
                showAlert(t('SUCCESS'), t('REMOVE_ADDRESS_SUCCESS'));
            } else {
                showAlert(t('ERROR'), t('FAILED_TO_REMOVE_ADDRESS'));
            }
        } catch (error) {
            console.log("remove address exception:", error);
            showAlert(t('ERROR'), t('EXCEPTION_PROCESS'));
        }
        onShowLoading(false)
    }

    const onAddAddresses = () => {
        setAddAddresses(prevState => ({
            ...prevState,
            open: true,
            mode: 'add',
            address: {}
        }))
    }

    var isEditDOB = true;
    var date_of_birth = profile_demographics && profile_demographics.date_of_birth ? profile_demographics.date_of_birth : null;
    if (date_of_birth && date_of_birth.year && date_of_birth.month && date_of_birth.day) {
        isEditDOB = false;
    }
    var is_supported_dob = getSupportProfileDetail("BIRTHDATE");
    var is_supported_nameday = getSupportProfileDetail("NAMEDAY");
    var is_supported_gender = getSupportProfileDetail("GENDER");
    return (
        <div>
            <MyProfileView
                showLoading={showLoading}
                open={props.open}
                handleDrawerToggle={props.handleDrawerOtherToggle}
                profile={profile}
                profile_demographics={profile_demographics}
                profile_phone={profile_phone}
                preferredCommunicationMethod={preferredCommunicationMethod}
                preferredCommunicationMethods={preferredCommunicationMethods}
                isLoadedPreferred={isLoadedPreferred}
                favourite_shop={getOrderCache(order_key.order_favourite_shop)}
                onSubmit={onEdit}
                onChangeGender={onChangeGender}
                country_select={country_select}
                onOpenChangePassword={() => onOpenChangePassword(!isChangePassword)}
                onSelectCountry={onSelectCountry}
                onSelectNameDay={onSelectNameDay}
                auth_support={auth_support}
                features={features}
                onShowMerchantList={onShowMerchantList}
                is_supported_dob={is_supported_dob}
                is_supported_nameday={is_supported_nameday}
                is_supported_gender={is_supported_gender}
                isEditDOB={isEditDOB}
                onOpenAddress={() => onOpenAddress(!openAddress)}
                list_nameday={list_nameday}
                isNameDay={isNameDay}
                addresses={addresses}
                onShowDetailAddress={onShowDetailAddress}
                onRemoveAddress={onRemoveAddress}
                onAddAddresses={onAddAddresses}
                onSelectMethod={onSelectMethod}
            />
            {isChangePassword && <ChangePassword
                showLoading={showLoading}
                open={isChangePassword}
                onClose={() => onOpenChangePassword(!isChangePassword)}
                onChangePassword={onChangePassword}
            />}
            {openAddress && <Addresses
                open={openAddress}
                onCloseItem={() => onOpenAddress(!openAddress)} />
            }
            {showListMerchant && <MerrchantVenueStore
                showLoading={showLoading}
                open={showListMerchant}
                onClose={onShowMerchantList}
                onUpdatePreferrence={onUpdatePreferrence}
                data={preference_type === preferences_type.order ? venues : merchants}
            />}
            <ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
                error={error.status}
            />
            {addAddresses.open && <AddAdresses
                open={addAddresses.open}
                mode={addAddresses.mode}
                address={addAddresses.address}
                onClose={onCloseAddAddresses}
                onLoadAddresses={onLoadAddresses} />}
            {showProcessLoading && <Loading showLoading={showProcessLoading} />}
        </div>
    );
}


// export default MyProfile;
export default withStyles(styles)(withTranslation()(MyProfile));